"use client";
import * as React from "react";
const SvgWorkRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M15.8 3.37h-3.4V1.68C12.4.75 11.64 0 10.7 0H7.3c-.94 0-1.7.75-1.7 1.68v1.69H2.2A1.7 1.7 0 0 0 .5 5.05v9.27c0 .93.76 1.68 1.7 1.68h13.6c.94 0 1.7-.75 1.7-1.68V5.05c0-.93-.76-1.68-1.7-1.68m-5.1 0H7.3V1.68h3.4z" }));
export {
  SvgWorkRound as default
};
